var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiTelephoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:telephone-fill",
    clipPath: "url(#clip0_429_87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12067 0.574796C2.31751 0.378246 2.55388 0.225774 2.81411 0.127485C3.07434 0.0291955 3.35249 -0.0126669 3.63012 0.00467186C3.90776 0.0220106 4.17853 0.0981545 4.42451 0.228058C4.67049 0.357961 4.88605 0.538657 5.05692 0.758171L7.07629 3.35242C7.44642 3.8283 7.57692 4.44817 7.43067 5.03317L6.81529 7.49692C6.78348 7.62453 6.78519 7.7582 6.82028 7.88494C6.85537 8.01169 6.92263 8.12722 7.01554 8.2203L9.77967 10.9844C9.87286 11.0775 9.98857 11.1449 10.1155 11.18C10.2425 11.2151 10.3764 11.2167 10.5042 11.1847L12.9668 10.5693C13.2555 10.4971 13.5568 10.4915 13.848 10.5529C14.1392 10.6143 14.4126 10.7411 14.6475 10.9237L17.2418 12.9419C18.1744 13.6675 18.2599 15.0457 17.4252 15.8793L16.2619 17.0425C15.4294 17.875 14.1852 18.2407 13.0253 17.8323C10.0566 16.7878 7.36122 15.0882 5.13904 12.8598C2.91074 10.6379 1.21123 7.94294 0.166542 4.97467C-0.240708 3.81592 0.124917 2.57055 0.957417 1.73805L2.12067 0.574796Z",
    fill: "#2192FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiTelephoneFill);
export default __webpack_public_path__ + "static/media/bi_telephone-fill.4c5dd2785008783b02a9eaf58d92ed12.svg";
export { ForwardRef as ReactComponent };